var timeoutHandle;
var bgImageArray = ["login-1.jpg", "login-2.jpg", "login-3.jpg"],
	base = "/images/",
	secs = 5;
bgImageArray.forEach(function (img) {
	new Image().src = base + img;
});

function backgroundSequence() {
	window.clearTimeout(timeoutHandle);
	var k = 0;
	var body = document.getElementsByTagName("body");
	if ($(body).hasClass("bodyAnimation")) {
		for (var i = 0; i < bgImageArray.length; i++) {
			timeoutHandle = setTimeout(function () {
				document.body.style.background = "url(" + base + bgImageArray[k] + ") no-repeat center center fixed";
				document.body.style.backgroundSize = "cover";
				if ((k + 1) === bgImageArray.length) { setTimeout(function () { backgroundSequence() }, (secs * 1000)) } else { k++; }
			}, (secs * 1000) * i)
		}
    }

}
//backgroundSequence();